/* eslint-disable eqeqeq */
import { PureComponent } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import { Grid, Segment } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Slider from 'rc-slider';
import {
  AvField,
  AvRadioGroup,
  AvRadio,
  AvCheckboxGroup,
  AvCheckbox,
} from 'availity-reactstrap-validation';

import { CustomTooltip } from './popup';
import { map, uniq, isEmpty, get } from '../utils/lodash';
import { DevelService } from '../services';

import 'rc-slider/assets/index.css';
import './styles.scss';

const marks = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  10: 10,
};

const trackStyle = {
  backgroundColor: '#dad3d3c9',
  height: '0.938rem',
  marginTop: '-1rem',
};

const handleStyle = {
  height: '3.125rem',
  width: '3.125rem',
  marginTop: '-2.188rem',
  marginLeft: DevelService.isProduction() ? '' : '-1.563rem',
  backgroundColor: '#ef8123',
  border: 'none',
};

const activeDotStyle = {
  borderColor: '#dad3d3c9',
  backgroundColor: '#dad3d3c9',
  height: '2rem',
  width: '2rem',
  border: 'none',
  marginLeft: '-0.875rem',
};

class SurveyReview extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      methods: [],
      reasonId: null,
      localRatings: {
        result1: get(props, 'ratingData.result1', 1),
        result2: get(props, 'ratingData.result2', 1),
      },
      hasTouchedRatings: false,
    };
  }

  componentDidMount() {
    const { data } = this.props;
    if (get(data, 'methodId', null) === 9) {
      const assessmentTypes = get(data, 'assessmentTypes', []);
      this.setState({
        methods: isEmpty(assessmentTypes)
          ? []
          : map(assessmentTypes, (data) => {
              return data.id;
            }),
        reasonId: get(data, 'methodReason', null),
      });
    }
  }

  componentDidUpdate(prevProps) {
    try {
      const { data } = this.props;
      if (!this.state.hasTouchedRatings) {
        const next1 = get(this.props, 'ratingData.result1', 1);
        const next2 = get(this.props, 'ratingData.result2', 1);

        if (
          next1 !== get(prevProps, 'ratingData.result1', 1) ||
          next2 !== get(prevProps, 'ratingData.result2', 1)
        ) {
          this.setState({
            localRatings: { result1: next1, result2: next2 },
          });
        }
      }
      if (get(data, 'methodId', null) === 9) {
        const assessmentTypes = get(data, 'assessmentTypes', []);
        const methodReason = get(data, 'methodReason', null);
        if (
          !isEmpty(assessmentTypes) &&
          get(prevProps, 'data.assessmentTypes', []) !== assessmentTypes
        ) {
          this.setState({
            methods: isEmpty(assessmentTypes)
              ? []
              : map(assessmentTypes, (data) => {
                  return data.id;
                }),
          });
        }

        if (
          methodReason &&
          get(prevProps, 'data.methodReason', null) !== methodReason
        ) {
          this.setState({
            reasonId: methodReason,
          });
        }
      }
    } catch (error) {
      console.error('SurveyReview :: componentDidUpdate -> error', error);
    }
  }

  onRatingChange(rating, name) {
    let { ratingData, updateResults } = this.props;
    ratingData[name] = rating;
    updateResults(ratingData);
  }

  handleReasonChange(id) {
    this.setState({
      reasonId: id,
    });
  }

  handleMethodChange(check, value, id) {
    try {
      const { ratingData, updateResults } = this.props;
      const methods = [...this.state.methods];
      let index = methods.indexOf(id);

      if (check === true) {
        methods.push(id);
        this.setState({
          methods: uniq(methods),
        });
      } else {
        if (methods.includes(id)) {
          if (index > -1) {
            methods.splice(index, 1);
          }
          this.setState({
            methods: uniq(methods),
          });
        }
      }
      ratingData.assessmentTypes = methods;
      updateResults(ratingData);
    } catch (error) {
      console.error('SurveyReview :: handleMethodChange -> error', error);
    }
  }

  updateLocalRating = (name, rating) => {
    this.setState((prev) => ({
      hasTouchedRatings: true,
      localRatings: {
        ...prev.localRatings,
        [name]: rating,
      },
    }));
  };

  beforeHigherThanAfter = () => {
    const { result1, result2 } = this.state.localRatings;
    if (result1 == null || result2 == null) return false;
    return result2 > result1; // before > after
  };

  render() {
    let {
      index,
      question,
      ratingData,
      objectiveId,
      evalView,
      cumulative,
      method,
      data,
      pageDisabled,
      lang,
      t,
    } = this.props;

    const { reasonId, methods, localRatings } = this.state;
    const i18nParams = lang ? { lng: lang } : {};

    return (
      <div>
        {evalView ? null : (
          <div>
            {question.methodHeading && index === 0 ? (
              <div className="method-heading-ctr">
                <div
                  className={`method-heading-box ${
                    lang === 'en' ? '' : 'hidden'
                  }`}
                  lang="en"
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: question.methodHeading,
                    }}
                  />

                  {/****
                    <br />
                    <div className="method-heading-todo">
                      TO DO: Add line about what two outcomes are being surveyed for... think that should improve flow of survey. Maybe like,
                      for this project we wish to understand how your participation has impacted your feelings around outcome 1 & ouctome two.
                      As well as how you felt before participation. Maybe add as new prop from backend.
                    </div>
                  ****/}
                </div>

                {Object.entries(question.altLanguages || {}).map(
                  ([thisLang, translations], idx) =>
                    translations.methodHeading ? (
                      <div
                        className={`method-heading-box ${
                          thisLang === lang ? '' : 'hidden'
                        }`}
                        lang={thisLang}
                        key={idx}
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html: translations.methodHeading,
                          }}
                        />
                      </div>
                    ) : null
                )}
              </div>
            ) : null}
          </div>
        )}

        {evalView ? (
          <div>
            <Grid.Row>
              <label className="eval-method-title">
                <strong>{t('survey.mgr_assessed_evaluation_method')}</strong>
              </label>
              {question.methodHeading ? (
                <div className="method-heading-box survey-gap">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: question.methodHeading,
                    }}
                  />
                </div>
              ) : null}

              <div className="eval-method-container">
                <label className="eval-method-header">
                  {t('survey.reason_for_evaluation_method')}
                </label>
                <Segment
                  disabled={
                    this.props.currentActivity.statusId == 3 || pageDisabled
                      ? true
                      : false
                  }
                >
                  <AvRadioGroup
                    name="methodReason"
                    className="eval-checkBox"
                    value={reasonId}
                    validate={{
                      required: {
                        value: true,
                        errorMessage: t(
                          'survey.reason_for_evaluation_method_required'
                        ),
                      },
                    }}
                  >
                    <Grid>
                      {map(evalView.evalReasons, (reason, i) => (
                        <Grid.Column
                          key={i}
                          mobile={16}
                          tablet={8}
                          computer={5}
                        >
                          <div className="eval-method-radio">
                            <AvRadio
                              name="reason"
                              type="radio"
                              label={reason.name}
                              value={reason.id}
                              onChange={() =>
                                this.handleReasonChange(reason.id)
                              }
                            />
                          </div>
                        </Grid.Column>
                      ))}
                    </Grid>
                  </AvRadioGroup>
                </Segment>
              </div>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column
                mobile={16}
                tablet={16}
                computer={16}
                style={{ marginTop: '0.938rem' }}
              >
                {question.heading ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: question.heading,
                    }}
                    className="survey-gap"
                  />
                ) : null}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <div className="eval-method-container">
                <label className="eval-method-header">
                  {t('survey.assessment_based_on')}
                </label>
                <Segment
                  disabled={
                    this.props.currentActivity.statusId == 3 || pageDisabled
                  }
                >
                  <AvCheckboxGroup
                    className="eval-checkBox"
                    name="assessmentTypes"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: t('survey.assessment_basis_required'),
                      },
                    }}
                  >
                    <Grid>
                      {map(evalView.evalAssesmentTypes, (types, i) => (
                        <Grid.Column
                          key={i}
                          mobile={16}
                          tablet={8}
                          computer={16}
                          className="grid-column-assessment"
                        >
                          <div className="eval-method-checkbox">
                            <AvCheckbox
                              name="evalAssessmentTypes"
                              label={types.name}
                              onChange={(e) =>
                                this.handleMethodChange(
                                  e.target.checked,
                                  e.target.value,
                                  types.id
                                )
                              }
                              value={types.id}
                              checked={
                                methods.includes(types.id) ? true : false
                              }
                            />
                          </div>
                        </Grid.Column>
                      ))}
                    </Grid>
                  </AvCheckboxGroup>
                </Segment>
              </div>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column mobile={16} tablet={8} computer={8}>
                <div className="disabled-padding">
                  <Segment
                    disabled={
                      this.props.currentActivity.statusId == 3 || pageDisabled
                    }
                  >
                    <div className="number-participants-div">
                      <CustomTooltip
                        className="number-participants-bottom"
                        position="bottom left"
                      >
                        <AvField
                          label={t('survey.number_of_participants_considered')}
                          className={`number-participants-input ${
                            (get(data, 'collectionMethod') == 'LINK' ||
                              get(data, 'collectionMethod') == 'CSV') &&
                            get(data, 'method.id', 0) !== 9
                              ? 'participants-disabled'
                              : ''
                          }`}
                          name="actualParticipantsEvaluated"
                          disabled={
                            (get(data, 'collectionMethod') == 'LINK' ||
                              get(data, 'collectionMethod') == 'CSV') &&
                            get(data, 'method.id', 0) !== 9
                              ? true
                              : false
                          }
                          type="number"
                          min="1"
                          validate={{
                            required: {
                              value: true,
                              errorMessage: t(
                                'formulary.validation.number_of_participants_required'
                              ),
                            },
                          }}
                        />
                      </CustomTooltip>
                    </div>
                  </Segment>
                </div>
              </Grid.Column>
            </Grid.Row>
          </div>
        ) : null}

        <div className="my-2">
          <Segment
            disabled={this.props.currentActivity.statusId == 3 || pageDisabled}
          >
            {Boolean(cumulative) ? (
              <div>
                <div className="survey-gap">
                  <div className="my-3"></div>

                  {question.heading ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: question.heading,
                      }}
                      className={`qst-heading ${lang === 'en' ? '' : 'hidden'}`}
                      lang="en"
                    />
                  ) : null}

                  {Object.entries(question.altLanguages || {}).map(
                    ([thisLang, translations], idx) =>
                      translations.heading ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: translations.heading,
                          }}
                          className={`qst-heading ${
                            thisLang === lang ? '' : 'hidden'
                          }`}
                          lang={thisLang}
                          key={idx}
                        />
                      ) : null
                  )}

                  {/***********
                    I really don't understand the logic below:
                    question.question1 vs get(question, 'question1')
                    surely they are the same test???????
                  ***********/}

                  {question.question1 ? (
                    <>
                      <div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: question.question1,
                          }}
                          className={`mb-24 ${lang === 'en' ? '' : 'hidden'}`}
                          lang="en"
                        />
                      </div>

                      {Object.entries(question.altLanguages || {}).map(
                        ([thisLang, translations], idx) =>
                          translations.question1 ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: translations.question1,
                              }}
                              className={`mb-24 ${
                                thisLang === lang ? '' : 'hidden'
                              }`}
                              lang={thisLang}
                              key={idx}
                            />
                          ) : null
                      )}
                    </>
                  ) : get(question, 'question1') ? (
                    <div>
                      {question.heading ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: question.heading,
                          }}
                          className="survey-gap"
                        />
                      ) : null}

                      <div
                        dangerouslySetInnerHTML={{
                          __html: question.question1,
                        }}
                        className="survey-gap"
                      />
                    </div>
                  ) : null}

                  {/* this is for secondary outcome... */}
                  <label>{t('survey.select_response', i18nParams)}</label>

                  <div className="slider-margin">
                    <Slider
                      min={0.5}
                      value={localRatings.result1}
                      onChange={(rating) =>
                        this.updateLocalRating('result1', rating)
                      }
                      onAfterChange={(rating) =>
                        this.onRatingChange(rating, 'result1')
                      }
                      marks={marks}
                      max={10.5}
                      step={null}
                      trackStyle={isMobile ? '' : trackStyle}
                      handleStyle={isMobile ? '' : handleStyle}
                      activeDotStyle={isMobile ? '' : activeDotStyle}
                      dotStyle={isMobile ? '' : activeDotStyle}
                      railStyle={isMobile ? '' : trackStyle}
                    />
                  </div>

                  {!isMobile ? (
                    <div className="slider-info-text">
                      <label>{t('common.not_at_all', i18nParams)}</label>
                      <label>{t('common.most_imaginable', i18nParams)}</label>
                    </div>
                  ) : (
                    <>
                      <br />
                      <div className="slider-info-muted">
                        <label>{t('common.not_at_all', i18nParams)}</label>
                        <label>{t('common.most_imaginable', i18nParams)}</label>
                      </div>
                    </>
                  )}
                </div>

                <br />
                <hr />

                <div className="survey-gap">
                  {/***********
                    I really don't understand the logic below:
                    question.question1 vs get(question, 'question1')
                    surely they are the same test???????
                  ***********/}

                  {question.question2 ? (
                    <>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: question.question2,
                        }}
                        className={`mb-24 ${lang === 'en' ? '' : 'hidden'}`}
                        lang="en"
                      />

                      {Object.entries(question.altLanguages || {}).map(
                        ([thisLang, translations], idx) =>
                          translations.question2 ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: translations.question2,
                              }}
                              className={`mb-24 ${
                                thisLang === lang ? '' : 'hidden'
                              }`}
                              lang={thisLang}
                              key={idx}
                            />
                          ) : null
                      )}
                    </>
                  ) : get(question, 'question2') ? (
                    <div>
                      {question.heading ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: question.heading,
                          }}
                          className="survey-gap"
                        />
                      ) : null}
                      <div
                        dangerouslySetInnerHTML={{
                          __html: question.question2,
                        }}
                        className="survey-gap"
                      />
                    </div>
                  ) : null}
                  <label
                    dangerouslySetInnerHTML={{
                      __html: t('survey.select_before_response'),
                    }}
                  />
                  <>
                    <div className="slider-margin">
                      <Slider
                        min={0.5}
                        value={localRatings.result2}
                        onChange={(rating) =>
                          this.updateLocalRating('result2', rating)
                        }
                        onAfterChange={(rating) =>
                          this.onRatingChange(rating, 'result2')
                        }
                        marks={marks}
                        max={10.5}
                        step={null}
                        trackStyle={isMobile ? '' : trackStyle}
                        handleStyle={isMobile ? '' : handleStyle}
                        activeDotStyle={isMobile ? '' : activeDotStyle}
                        dotStyle={isMobile ? '' : activeDotStyle}
                        railStyle={isMobile ? '' : trackStyle}
                      />
                    </div>

                    {!isMobile ? (
                      <div className="slider-info-text">
                        <label>{t('common.not_at_all', i18nParams)}</label>
                        <label>{t('common.most_imaginable', i18nParams)}</label>
                      </div>
                    ) : (
                      <>
                        <br />
                        <div className="slider-info-muted">
                          <label>{t('common.not_at_all', i18nParams)}</label>
                          <label>
                            {t('common.most_imaginable', i18nParams)}
                          </label>
                        </div>
                      </>
                    )}
                  </>
                  {this.beforeHigherThanAfter() ? (
                    <div className="ui negative message rating-warning-message">
                      <Trans
                        i18nKey="survey.before_higher_than_after_fmt"
                        components={{ div: <div className="header" /> }}
                      />
                    </div>
                  ) : null}

                  <br />
                </div>
              </div>
            ) : (
              <div className="survey-gap">
                {question.heading ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: question.heading,
                    }}
                    className={`qst-heading ${lang === 'en' ? '' : 'hidden'}`}
                    lang="en"
                  />
                ) : null}

                {Object.entries(question.altLanguages || {}).map(
                  ([thisLang, translations], idx) =>
                    translations.heading ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: translations.heading,
                        }}
                        className={`qst-heading ${
                          thisLang === lang ? '' : 'hidden'
                        }`}
                        lang={thisLang}
                        key={idx}
                      />
                    ) : null
                )}

                <br />

                <div className="my-3"></div>
                {question.question1 ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: question.question1,
                    }}
                    className="mb-24"
                  />
                ) : get(question, 'question1') ? (
                  <div>
                    {question.heading ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: question.heading,
                        }}
                        className="survey-gap"
                      />
                    ) : null}

                    <div
                      dangerouslySetInnerHTML={{
                        __html: question.question1,
                      }}
                      className="survey-gap"
                    />
                  </div>
                ) : null}
                <label>{t('survey.select_your_response', i18nParams)}</label>
                <>
                  <div className="slider-margin">
                    <Slider
                      min={0.5}
                      defaultValue={ratingData.result1}
                      onAfterChange={(rating) =>
                        this.onRatingChange(rating, 'result1')
                      }
                      marks={marks}
                      max={10.5}
                      step={null}
                      trackStyle={isMobile ? '' : trackStyle}
                      handleStyle={isMobile ? '' : handleStyle}
                      activeDotStyle={isMobile ? '' : activeDotStyle}
                      dotStyle={isMobile ? '' : activeDotStyle}
                      railStyle={isMobile ? '' : trackStyle}
                    />
                  </div>

                  {!isMobile ? (
                    <div className="slider-info-text">
                      <label>{t('common.not_at_all', i18nParams)}</label>
                      <label>{t('common.most_imaginable', i18nParams)}</label>
                    </div>
                  ) : (
                    <>
                      <br />
                      <div className="slider-info-muted">
                        <label>{t('common.not_at_all', i18nParams)}</label>
                        <label>{t('common.most_imaginable', i18nParams)}</label>
                      </div>
                    </>
                  )}
                </>
                <br />
              </div>
            )}

            {get(method, 'method', null) === 'Intercept' ? null : (
              <Grid className="custom-gen-questions survey-gap">
                <Grid.Row>
                  <Grid.Column computer={8} mobile={16}>
                    <AvField
                      name={`${objectiveId}_Reason`}
                      className="custom-gen-questions-textarea-style"
                      type="textarea"
                      label={
                        cumulative
                          ? t('survey.tell_us_more_two_ratings', i18nParams)
                          : t('survey.tell_us_more_one_rating', i18nParams)
                      }
                      disabled={
                        this.props.currentActivity.statusId == 3 ? true : false
                      }
                      validate={{
                        required: {
                          value: true,
                          errorMessage: 'Field is required',
                        },
                      }}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            )}
          </Segment>
        </div>
        <br />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.activity,
    user: state.authentication.user,
    helpTips: state.extra.activityHelpTips,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

SurveyReview = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(SurveyReview));

export { SurveyReview };
